import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobEditInfoPage from '@/features/jobs/job-edit-info/JobEditInfoPage';

export const jobEditInfoRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar/informacoes-gerais',
  component: JobEditInfoPage,
});
